import { Theme } from '@mui/material';
import { merge } from 'lodash';
import Accordion from './Accordion';
import AccordionDetails from './AccordionDetails';
import AccordionSummary from './AccordionSummary';
import AppBar from './AppBar';
import Container from './Container';
import LoadingButton from './LoadingButton';
import PaginationItem from './PaginationItem';
import Paper from './Paper';

/* eslint-disable new-cap */
export default function ComponentsOverrides(theme: Theme) {
  return merge(
    Accordion(),
    AccordionDetails(),
    AccordionSummary(),
    AppBar(theme),
    Container(),
    LoadingButton(theme),
    Paper(theme),
    PaginationItem(theme)
  );
}
